import * as types from '@/store/modules/website-builder/types'

export default {
  [types.WEBSITE_STATUS](state, value) {
    state.websiteStatus = value
  },
}
